<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="pub-story-page">
    <Header />
    <SideBar :current="'story'" />

    <div class="page-main">
      <div class="video-type-nav">
        <div class="second-nav-list">
          <a href="/story-publish" class="item focus"> 发布文物故事 </a>
          <a href="/story-manage/-1" class="item"> 文物故事管理 </a>
        </div>
      </div>
      <div class="edit-wrap">
        <el-form
          class="story-title"
          :model="formData"
          ref="formDom"
          :label-position="right"
          label-width="120px"
        >
          <el-form-item
            class="title-input"
            label=""
            prop="title"
            :rules="[{ required: true, message: '文章标题必须填写' }]"
          >
            <el-input
              class="m-input count"
              maxlength="50"
              show-word-limit
              v-model="formData.title"
              placeholder="文章标题 5-50个字符"
            ></el-input>
          </el-form-item>
          <el-form-item class="foreword-input" label="" prop="foreword">
            <el-input
              class="m-input count"
              maxlength="100"
              show-word-limit
              type="textarea"
              :rows="2"
              v-model="formData.foreword"
              placeholder="文章引言 5-100个字符"
            ></el-input>
          </el-form-item>

          <RichTextEditor
            v-model="editorContent"
            placeholder="在这里输入内容，支持插入图片和文物..."
            style="margin-bottom: 15px"
            @change="handleEditorChange"
          />
          <el-form-item label="文物故事封面" required>
            <el-row>
              <el-col :span="10" class="upload-img-item">
                <div class="upload-img-wrap cross">
                  <ImgCropUpload
                    :src="formData.crossImg"
                    :crop="true"
                    :cropWidth="960"
                    :cropHeight="540"
                    :cropList="true"
                    :imgs="snapshotVideoList"
                    @success="imgUploadSuccess($event, 'crossImg')"
                  />
                </div>
                <span class="tip-text mt6"
                  >上传文物故事封面（<i>960x540px</i>）</span
                >
                <el-form-item
                  class="hidden"
                  prop="crossImg"
                  :rules="[{ required: true, message: '请上传文物故事封面' }]"
                >
                  <el-input
                    type="hidden"
                    v-model="formData.crossImg"
                    placeholder="请上传文物故事封面"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form-item>

          <el-form-item label="标签" class="tags-form">
            <div class="tags-box">
              <el-tag
                v-for="tag in formData.tags"
                :key="tag"
                type="success"
                closable
                @close="handleCloseTag(tag)"
                >{{ tag }}</el-tag
              >
            </div>
          </el-form-item>
          <div class="tips">请从下方选择框选择标签</div>
          <el-form-item label="" class="cascader-form">
            <el-cascader
              v-model="selectedOptions"
              :options="options"
              @change="handleChangeCascader"
              @expand-change="handleExpandChange"
              :show-all-levels="false"
              :props="cascaderProps"
              placeholder="请选择标签"
              clearable
              multiple
            >
            </el-cascader>
          </el-form-item>
          <el-form-item label="内容创作声明">
            <el-select
              clearable
              v-model="formData.copyrightNotice"
              placeholder="请选择"
            >
              <el-option
                v-for="item in isUseAIArr"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="虚拟性标注">
            <el-select
              clearable
              v-model="formData.fictionalNotice"
              placeholder="请选择"
            >
              <el-option
                v-for="item in xuniArr"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="转载设置">
            <el-select
              clearable
              v-model="formData.reprintNotice"
              placeholder="请选择"
              popper-append-to-body
            >
              <el-option
                v-for="item in zhuanzaiArr"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            key="agree"
            label=""
            prop="checked"
            :rules="[
              { required: true, message: '请同意相关协议' },
              {
                validator: formRules.isTrue,
                message: '请同意相关协议',
                trigger: 'change',
              },
            ]"
          >
            <div class="agree-protocol">
              <el-checkbox class="m-checkbox" v-model="formData.checked"
                >我已阅读并接受</el-checkbox
              ><a
                target="_blank"
                href="https://omgotv.mgtv.com/protocol/SH_creator_covenant"
                >《山海社区公约》</a
              >
            </div>
          </el-form-item>
        </el-form>
        <!-- 发布按钮区域 -->
        <div class="publish-area form-btn-wrap">
          <el-button
            type="primary"
            size="medium"
            :disabled="!editorParams.html || editorParams.html.trim() === ''"
            @click="handlePublish"
            class="m-btn publish"
          >
            发布内容
          </el-button>
          <el-button
            type="primary"
            size="medium"
            class="m-btn draft"
            v-if="!isEdit"
            @click="handleSaveDraft(true)"
            >存草稿</el-button
          >
          <el-button
            class="m-btn cancel"
            type="primary"
            size="medium"
            @click="cancel()"
            >取消</el-button
          >
        </div>
      </div>
      <div>&nbsp;&nbsp;&nbsp;</div>
    </div>
  </div>
</template>

<script>
/*eslint-disable*/
import Header from '@/components/Header.vue';
import SideBar from '@/components/SideBar.vue';
import RichTextEditor from '@/components/RichTextEditor.vue';
import ImgCropUpload from '@/components/ImgCropUpload';
import {
  publish,
  editFeed,
  saveDraft,
  getDraftDetail,
  publishDraft,
  getTagType,
  getTagList,
  getUserInfo,
  getFeedDetail,
} from '@/servies/index.js';

export default {
  data() {
    return {
      posting: false,
      selectedOptions: [],
      options: [],
      isUseAIArr: [
        {
          value: 0,
          label: '无',
        },
        {
          value: 1,
          label: '内容原创声明',
        },
        {
          value: 2,
          label: '创作过程使用了AI工具',
        },
      ],
      zhuanzaiArr: [
        {
          value: 1,
          label: '允许转载',
        },
        {
          value: 0,
          label: '禁止转载',
        },
      ],
      xuniArr: [
        {
          value: 0,
          label: '无',
        },
        {
          value: 1,
          label: '完全史实',
        },
        {
          value: 2,
          label: '部分史实',
        },
      ],
      editorContent: '',
      editorParams: {
        html: '',
        text: '',
        length: 0,
        charCount: 0,
        isValid: true,
      },
      formData: {
        title: '',
        content: '',
        crossImg: '',
        tags: [],
        copyrightNotice: 0,
        fictionalNotice: 0,
        reprintNotice: 0,
        checked: false,
      },
      idStrIamge: '',
      snapshotVideoList: [],
      cascaderProps: {
        value: 'value',
        label: 'label',
        children: 'children',
        checkStrictly: false,
        multiple: false,
        emitPath: true,
      },
      editOriTagArr: [],
      storyDetail: {},
    };
  },
  components: {
    Header,
    SideBar,
    RichTextEditor,
    ImgCropUpload,
  },
  computed: {},
  created() {
    this.checkUserStatus();
    const vid = this.$route.params.vid;
    // 来源 5草稿  3未通过
    const from = this.$route.params.status;
    if (vid) {
      this.videoId = vid;
      this.from = from;
      this.isEdit = true;
      if (from == 5) {
        this.fetchDraftDetail();
      } else {
        this.fetchDetail();
      }
    }
  },

  mounted() {
    this.fetchTagTypeList();
  },
  methods: {
    checkUserStatus() {
      getUserInfo({})
        .then((response) => {
          if (response.data.code === 200 && response.data.data) {
            console.log('已登录');
          } else {
            this.$message({
              message: response.data.msg,
              type: 'error',
            });
            setTimeout(() => {
              this.$utils.clearLoginUserCookie();
              window.location.href = '/login';
            }, 1000);
          }
        })
        .catch((error) => {
          // 这里能捕获 402、404、500 等所有非 2xx 的 HTTP 错误
          if (error.response) {
            // 服务器有响应，error.response.status 就是状态码
            this.$message({
              message: error.response.data.msg,
              type: 'error',
            });
            setTimeout(() => {
              this.$utils.clearLoginUserCookie();
              window.location.href = '/login';
            }, 1000);
          } else {
            // 服务器无响应或网络错误
            this.$message({
              message: '网络异常或服务器无响应',
              type: 'error',
            });
            setTimeout(() => {
              this.$utils.clearLoginUserCookie();
              window.location.href = '/login';
            }, 1000);
          }
          console.error(error);
        });
    },
    // 标签二级菜单数据拉取
    handleExpandChange(val) {
      if (val.length === 1) {
        const tagTypeName = val[0];
        getTagList({ tagTypeId: tagTypeName }).then((response) => {
          if (response.data.code === 200 && response.data.data.contentTags) {
            this.options = this.options.map((item) => {
              if (item.value === tagTypeName) {
                return {
                  ...item,
                  children: response.data.data.contentTags.map((tag) => ({
                    value: tag.tagId,
                    label: tag.tagName,
                    tagId: tag.tagId,
                    tagName: item.tagName,
                  })),
                };
              }
              return item;
            });
          }
        });
      }
    },
    // 标签一级菜单数据拉取
    fetchTagTypeList() {
      getTagType({}).then((response) => {
        if (
          response.data.code === 200 &&
          response.data.data.contentTagTypes &&
          response.data.data.contentTagTypes.length > 0
        ) {
          let data = response.data.data.contentTagTypes;
          this.options = data.map((item) => ({
            value: item.tagTypeId,
            label: item.tagTypeName,
            tagId: item.tagTypeId,
            tagName: item.tagTypeName,
            children: [],
          }));
        }
      });
    },
    // 删除标签
    handleCloseTag(tag) {
      this.formData.tags.splice(this.formData.tags.indexOf(tag), 1);
    },
    // 选择标签
    handleChangeCascader(val) {
      if (this.formData.tags.length > 9) {
        this.$message.error('只可选择10个标签');
        return;
      }
      if (val && val.length > 0) {
        // 只取最后一级的标签名
        let selectedLabel = val[val.length - 1];

        const parentOption = this.options.find((item) => item.value === val[0]);
        if (parentOption && parentOption.children) {
          const childOption = parentOption.children.find(
            (item) => item.value === val[1]
          );
          selectedLabel = childOption ? childOption.label : val[1];
        }
        // 校验是否重复
        if (this.formData.tags.includes(selectedLabel)) {
          this.$message.error('该标签已存在，请选择其他标签');
          this.selectedOptions = [];
          return;
        }

        // 如果不重复，则添加到标签数组
        this.formData.tags.push(selectedLabel);
      }
      this.selectedOptions = [];
    },
    fetchDraftDetail() {
      getDraftDetail({
        id: this.videoId,
      }).then((res) => {
        let response = res.data;
        if (response.code == 200 && response.data) {
          this.setDetailData(response.data);
        }
      });
    },
    formatContentToHtml(jsonArray) {
      console.log('🔄 开始将JSON数据解析为HTML');

      if (typeof jsonArray === 'string') {
        try {
          jsonArray = JSON.parse(jsonArray);
        } catch (error) {
          console.error('❌ JSON解析失败:', error);
          return '';
        }
      }

      let htmlString = '';

      jsonArray.forEach((item, index) => {
        console.log(
          `📝 处理第${index + 1}项:`,
          item.type,
          item.content?.substring?.(0, 30)
        );

        switch (item.type) {
          case 'foreword':
            // 跳过前言，不处理
            console.log('⏭️ 跳过前言');
            break;

          case 'title':
            // 处理标题 -> H4标签
            if (item.content && item.content.trim()) {
              htmlString += `<h4>${item.content}</h4>`;
              console.log(`✅ 添加标题: ${item.content}`);
            }
            break;

          case 'text':
            // 处理文本 -> P标签
            if (item.content && item.content.trim()) {
              htmlString += `<p>${item.content}</p><p><br></p>`;
              console.log(
                `✅ 添加文本段落: ${item.content?.substring(0, 30)}...`
              );
            }
            break;

          case 'image':
            // 处理图片
            if (item.content) {
              const imageUrl = item.content; // 现在content直接是完整URL
              const width = item.width || 300;
              const height = item.height || 200;
              const desc = item.desc || '';

              // 从URL中提取文件ID（用于data-file-id）
              let fileId = item.imgId;

              let imgHtml = `<p><img src="${imageUrl}" data-file-id="${fileId}" data-width="${width}" data-height="${height}">`;

              // 如果有描述，添加描述
              if (desc) {
                imgHtml += `<em class="image-desc" data-image-desc="1">${desc}</em>`;
              }

              imgHtml += `</p><p><br></p>`;
              htmlString += imgHtml;

              console.log(
                `✅ 添加图片: ${fileId}${desc ? ` (描述: ${desc})` : ''}`
              );
            }
            break;

          case 'collection':
            // 处理文物
            if (item.content) {
              const artifactUrl = item.coverUrl;
              const artifactName = item.collectName || item.name || '';
              const artifactDesc = item.desc || '';

              let artifactHtml = `<p><img src="${artifactUrl}" data-artifact-id="${item.content}" data-artifact-name="${artifactName}" style="border: 2px solid rgb(4, 203, 205); border-radius: 4px; padding: 2px;">`;

              // 如果有描述，添加描述
              if (artifactDesc) {
                artifactHtml += `<i class="artifact-desc" data-artifact-desc="1">${artifactDesc}</i>`;
              }

              artifactHtml += `</p><p><br></p>`;
              htmlString += artifactHtml;

              console.log(
                `✅ 添加文物: ${item.content} (${artifactName})${
                  artifactDesc ? ` 描述: ${artifactDesc}` : ''
                }`
              );
            }
            break;

          default:
            console.log(`⚠️ 未知类型: ${item.type}`);
            break;
        }
      });

      // 移除末尾多余的空行
      htmlString = htmlString.replace(/(<p><br><\/p>)+$/, '');

      console.log('✅ JSON到HTML转换完成');
      console.log('📋 生成的HTML长度:', htmlString.length);

      return htmlString;
    },

    // 验证编辑器内容完整性
    validateEditorContent() {
      console.log('🔍 验证编辑器当前内容:', this.editorContent);

      // 解析HTML检查图片属性
      const parser = new DOMParser();
      const doc = parser.parseFromString(this.editorContent, 'text/html');
      const images = doc.querySelectorAll('img');

      images.forEach((img, index) => {
        console.log(`🖼️ 图片${index + 1}:`, {
          src: img.getAttribute('src'),
          'data-file-id': img.getAttribute('data-file-id'),
          'data-width': img.getAttribute('data-width'),
          'data-height': img.getAttribute('data-height'),
          'data-artifact-id': img.getAttribute('data-artifact-id'),
          'data-artifact-name': img.getAttribute('data-artifact-name'),
          style: img.getAttribute('style'),
        });
      });
    },

    fetchDetail() {
      getFeedDetail({
        id: this.videoId,
      }).then((res) => {
        let response = res.data;
        if (response.code == 200 && response.data) {
          this.storyDetail = response.data;
          this.setDetailData(this.storyDetail);
        }
      });
    },
    setDetailData(feedInfo) {
      let contentArr = JSON.parse(feedInfo.content);
      let data = {
        tags: feedInfo.contentTags?.map((item) => item.tagName),
        foreword: contentArr.find((item) => item.type === 'foreword')?.content,
        crossImg: feedInfo.cover?.url,
      };

      // 生成HTML内容
      const htmlContent = this.formatContentToHtml(contentArr);
      console.log('setDetailData 生成的HTML:', htmlContent);

      // 延迟设置编辑器内容，确保编辑器组件已经完全初始化
      this.$nextTick(() => {
        this.editorContent = htmlContent;
        console.log('setDetailData 设置后的编辑器内容:', this.editorContent);

        // 再次延迟检查编辑器实际DOM状态
        setTimeout(() => {
          console.log('🔍 检查编辑器实际DOM状态...');
          this.validateEditorContent();
        }, 1000);
      });

      this.idStrIamge = feedInfo.cover?.id;
      this.editOriTagArr = feedInfo.contentTags;
      this.formData = { ...feedInfo, ...data };
    },
    imgUploadSuccess(data, target) {
      this.idStrIamge = data.idStrImage;
      // this.crossImg = data.url
      this.formData[target] = data.url;
      // this.formData.crossImg = {
      //   id: data.idStrImage
      // }
    },
    handleEditorChange(data) {
      this.editorParams = data;
    },
    submitData() {
      if (this.posting) return;
      this.posting = true;
      let data = {};
      // const publishData = {
      //   html: this.editorContent, // HTML 格式的内容
      //   text: this.editorParams.text, // 纯文本内容
      //   length: this.editorParams.length, // 文本长度
      //   format: this.convertHTMLToJSON(),
      // };
      data = {
        // htmlStr: this.editorContent,
        content: this.convertHTMLToJSON().content,
        // contentArr: this.convertHTMLToJSON().contentArr,
        copyrightNotice: this.formData.copyrightNotice,
        feedType: 6,
        subTitle: this.formData.foreword,
        title: this.formData.title,
        fictionalNotice: this.formData.fictionalNotice,
        reprintNotice: this.formData.reprintNotice,
        tagIds: this.mergeArraysAndFindTagIds().join(','),
        cover: {
          id: this.idStrIamge,
          width: 960,
          height: 540,
        },
      };
      // 发布草稿
      if (this.from == 5 && this.isEdit) {
        data.feedDraftId = this.formData.id;
        publishDraft(data)
          .then((response) => {
            const { code, msg } = response.data;
            if (code === 200) {
              let msg = '发布成功，正在审核';
              this.$message({
                message: msg,
                type: 'success',
              });
              // 跳审核中
              this.$router.replace('/story-manage/2');
            } else {
              this.$message({
                message: msg,
                type: 'error',
              });
            }
            this.posting = false;
          })
          .catch((error) => {
            this.$message({
              message: error.response.data.msg,
              type: 'error',
            });
            this.posting = false;
          });
      } else if (this.$route.name === 'StoryEdit') {
        data.feedId = this.formData.id;
        editFeed(data)
          .then((response) => {
            const { code, msg } = response.data;
            if (code === 200) {
              let msg = '二次编辑发布成功，正在审核';
              this.$message({
                message: msg,
                type: 'success',
              });
              this.posting = false;
              // 跳审核中
              this.$router.push({ path: '/story-manage/2' });
            } else {
              this.posting = false;
              this.$message({
                message: msg,
                type: 'error',
              });
            }
            this.posting = false;
          })
          .catch((error) => {
            this.$message({
              message: error.response.data.msg,
              type: 'error',
            });
            this.posting = false;
          });
      } else {
        publish(data)
          .then((response) => {
            const { code, msg } = response.data;
            if (code === 200) {
              let msg = '发布成功，正在审核';
              this.$message({
                message: msg,
                type: 'success',
              });
              this.posting = false;
              // 跳审核中
              this.$router.push({ path: '/story-manage/2' });
            } else {
              this.posting = false;
              this.$message({
                message: msg,
                type: 'error',
              });
            }
            this.posting = false;
          })
          .catch((error) => {
            this.$message({
              message: error.response.data.msg,
              type: 'error',
            });
            this.posting = false;
          });
      }
    },
    handleSaveDraft() {
      if (this.posting) return;
      if (this.idStrIamge === '') {
        this.$message({
          message: '请上传封面',
          type: 'error',
        });
        return;
      }
      if (this.formData.title === '') {
        this.$message({
          message: '请填写标题',
          type: 'error',
        });
        return;
      }
      if (!this.editorParams.html || this.editorParams.html.trim() === '') {
        this.$message({
          message: '请填写正文',
          type: 'error',
        });
        return;
      }
      this.posting = true;
      let data = {};
      // const publishData = {
      //   html: this.editorContent, // HTML 格式的内容
      //   text: this.editorParams.text, // 纯文本内容
      //   length: this.editorParams.length, // 文本长度
      //   format: this.convertHTMLToJSON(),
      // };
      data = {
        // htmlStr: this.editorContent,
        content: this.convertHTMLToJSON().content,
        //contentArr: this.convertHTMLToJSON().contentArr,
        copyrightNotice: this.formData.copyrightNotice,
        feedType: 6,
        title: this.formData.title,
        fictionalNotice: this.formData.fictionalNotice,
        reprintNotice: this.formData.reprintNotice,
        tagIds: this.mergeArraysAndFindTagIds().join(','),
        cover: {
          id: this.idStrIamge,
          width: 960,
          height: 540,
        },
      };
      saveDraft(data)
        .then((response) => {
          const { code, msg } = response.data;
          if (code === 200) {
            let msg = '保存成功';
            this.$message({
              message: msg,
              type: 'success',
            });
            this.posting = false;
            this.$router.push({ path: '/story-manage/5' });
          } else {
            this.posting = false;
            this.$message({
              message: msg,
              type: 'error',
            });
          }
          this.posting = false;
        })
        .catch((error) => {
          this.$message({
            message: '文本格式不符合规范，请重试',
            type: 'error',
          });
          this.posting = false;
        });
    },
    // 格式化ID
    formateTagIds(selectedOptions) {
      const ids = selectedOptions.map((item) => item[1]).join(',');
      return ids;
    },

    // 合并数组并找出 tagId
    mergeArraysAndFindTagIds() {
      const tagArr = this.formData.tags || []; // ["tag9", "tag10"]
      let tagOptionArr = this.options;
      if (this.editOriTagArr?.length > 0) {
        tagOptionArr = this.editOriTagArr?.concat(this.options);
      }

      console.log('tagArr (要查找的标签名):', tagArr);
      console.log('tagOptionArr (包含标签信息的数组):', tagOptionArr);

      const tagIds = [];

      // 遍历 tagArr 中的每一项
      tagArr.forEach((tagName) => {
        let foundTagId = null;

        // 在 tagOptionArr 中查找匹配的 tagName
        for (let item of tagOptionArr) {
          // 检查当前项是否有 tagName 属性且匹配
          if (item.tagName === tagName) {
            foundTagId = item.tagId;
            break;
          }

          // 检查 children 数组
          if (item.children && item.children.length > 0) {
            for (let child of item.children) {
              if (child.label === tagName) {
                foundTagId = child.value; // 使用 value 作为 tagId
                break;
              }
            }
            if (foundTagId) break;
          }
        }
        if (foundTagId) {
          tagIds.push(foundTagId);
        } else {
          console.warn(`未找到标签 "${tagName}" 对应的 tagId`);
        }
      });
      return tagIds;
    },
    // 发布内容
    handlePublish() {
      // 二次编辑的时候，replicaStatus = 0
      if (this.$route.name === 'StoryEdit') {
        this.$confirm(``, '确定修改内容并重新发布？', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          center: true,
        }).then(async () => {
          this.publishValidate();
        });
      } else {
        this.publishValidate();
      }
    },
    publishValidate() {
      this.$refs.formDom.validate((valid) => {
        if (valid) {
          if (!this.editorParams.isValid) {
            this.$message({
              message: '文本数据长度不符合规范！',
              type: 'error',
            });
            return;
          } else {
            this.submitData();
          }
          this.submitData();
        } else {
          this.$message({
            message: '数据填写不符合规范！',
            type: 'error',
          });
          return;
        }
      });
    },
    convertHTMLToJSON() {
      console.log('convertHTMLToJSON >>>' + this.editorContent);
      // 先把引言塞进数组
      let foreword = [
        {
          type: 'foreword',
          content: this.formData.foreword || '',
        },
      ];
      let paragraph = this.parseRichTextToJSON(this.editorContent);
      return {
        contentArr: foreword.concat(paragraph),
        content: JSON.stringify(foreword.concat(paragraph)),
      };
    },
    parseRichTextToJSON(htmlString) {
      console.log('🔍 parseRichTextToJSON 接收到的HTML:', htmlString);

      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlString, 'text/html');
      const paragraph = [];

      // 遍历所有直接子节点（h4/p）
      Array.from(doc.body.children).forEach((element) => {
        if (element.tagName === 'H4') {
          // 处理标题，过滤掉空内容
          const titleContent = element.textContent.trim();
          if (titleContent) {
            paragraph.push({
              type: 'title',
              content: titleContent,
            });
          }
        } else if (element.tagName === 'P') {
          // 检查是否包含文物图片
          const artifactImg = element.querySelector('img[data-artifact-id]');
          if (artifactImg) {
            // 这是文物图片段落
            const artifactId = artifactImg.getAttribute('data-artifact-id');
            const artifactName =
              artifactImg.getAttribute('data-artifact-name') || '';
            let artifactDesc = '';

            // 查找文物描述
            const artifactDescElement = element.querySelector(
              'i.artifact-desc[data-artifact-desc="1"]'
            );
            if (artifactDescElement) {
              artifactDesc = artifactDescElement.textContent.trim();
            }

            paragraph.push({
              type: 'collection',
              content: artifactId,
              name: artifactName,
              desc: artifactDesc,
            });
            return; // 跳过后续处理
          }

          // const strong = element.querySelector('strong');
          // const em = element.querySelector('i.artifact-desc');

          // if (strong && em && strong.textContent.includes('[关联文物-')) {
          //   // 解析文物ID和名称
          //   const strongText = strong.textContent.trim();
          //   const idMatch = strongText.match(/关联文物-(\d+)-(.+?)\]/);

          //   if (idMatch && idMatch[1]) {
          //     const artifactId = idMatch[1];
          //     const artifactName = idMatch[2];
          //     const desc = em.textContent.trim();

          //     paragraph.push({
          //       type: 'collection',
          //       content: artifactId, // 文物ID
          //       // name: artifactName, // 文物名称
          //       desc: desc, // 文物描述
          //     });
          //   }
          //   return;
          // }

          // 3. 其它普通P标签的处理逻辑
          const nodes = Array.from(element.childNodes);
          let currentText = '';

          // 递归提取所有文本内容，忽略格式标签
          const extractTextFromNode = (node) => {
            if (node.nodeType === Node.TEXT_NODE) {
              return node.textContent || '';
            } else if (node.nodeType === Node.ELEMENT_NODE) {
              const tagName = node.tagName.toLowerCase();

              // 跳过图片和描述标签（这些会单独处理）
              if (
                ['img', 'em'].includes(tagName) &&
                (node.classList.contains('image-desc') ||
                  node.classList.contains('artifact-desc') ||
                  node.hasAttribute('data-image-desc') ||
                  node.hasAttribute('data-artifact-desc'))
              ) {
                return '';
              }

              // 对于其他标签（a, strong, b, i, u, span等），提取其文本内容
              let text = '';
              for (let child of node.childNodes) {
                text += extractTextFromNode(child);
              }
              return text;
            }
            return '';
          };

          nodes.forEach((node) => {
            if (node.nodeName === '#text' && node.textContent.trim()) {
              // 直接文本节点
              const textContent = node.textContent.trim();
              if (textContent) {
                paragraph.push({
                  type: 'text',
                  content: textContent,
                });
              }
              currentText = '';
            }
            // 图片节点
            else if (node.nodeName === 'IMG') {
              console.log('🖼️ 发现图片节点:', node);
              console.log('🔍 图片src:', node.getAttribute('src'));
              console.log(
                '🔍 data-artifact-id:',
                node.getAttribute('data-artifact-id')
              );
              console.log(
                '🔍 data-file-id:',
                node.getAttribute('data-file-id')
              );
              console.log('🔍 data-width:', node.getAttribute('data-width'));
              console.log('🔍 data-height:', node.getAttribute('data-height'));

              // 检查是否为文物图片
              const artifactId = node.getAttribute('data-artifact-id');
              if (artifactId) {
                console.log('✅ 识别为文物图片');
                // 这是文物图片
                const artifactName =
                  node.getAttribute('data-artifact-name') || '';
                let artifactDesc = '';
                const artifactDescElement = element.querySelector(
                  'em.artifact-desc[data-artifact-desc="1"]'
                );
                if (artifactDescElement) {
                  artifactDesc = artifactDescElement.textContent.trim();
                }

                paragraph.push({
                  type: 'collection',
                  content: artifactId,
                  name: artifactName,
                  desc: artifactDesc,
                });
              } else {
                console.log('✅ 识别为普通图片');
                console.log(node);

                // 这是普通图片
                let imageDesc = '';
                const imageDescElement = element.querySelector(
                  'em.image-desc[data-image-desc="1"]'
                );
                if (imageDescElement) {
                  imageDesc = imageDescElement.textContent.trim();
                }

                const fileId = node.getAttribute('data-file-id');
                const width = parseInt(node.getAttribute('data-width'));
                const height = parseInt(node.getAttribute('data-height'));

                console.log('📝 普通图片信息:', {
                  fileId,
                  width,
                  height,
                  imageDesc,
                });

                paragraph.push({
                  type: 'image',
                  width: width,
                  height: height,
                  content: fileId,
                  desc: imageDesc, // 存储图片描述
                });
              }
            }
            // 处理其他标签中的文本内容
            else if (node.nodeType === Node.ELEMENT_NODE) {
              const tagName = node.tagName.toLowerCase();

              // 跳过描述标签（这些在处理图片时已经处理过）
              if (
                (tagName === 'em' || tagName === 'i') &&
                (node.classList.contains('image-desc') ||
                  node.classList.contains('artifact-desc') ||
                  node.hasAttribute('data-image-desc') ||
                  node.hasAttribute('data-artifact-desc'))
              ) {
                return; // 跳过描述标签
              }

              // 提取嵌套标签中的文本内容
              const textContent = extractTextFromNode(node).trim();
              if (textContent) {
                console.log(
                  `📝 从 ${tagName.toUpperCase()} 标签中提取文本: "${textContent}"`
                );
                paragraph.push({
                  type: 'text',
                  content: textContent,
                });
              }
            }
          });

          // 处理段落末尾剩余的文本
          if (currentText.trim()) {
            paragraph.push({
              type: 'text',
              content: currentText.trim(),
            });
          }
        }
      });

      return paragraph;
    },
    cancel() {
      this.$confirm(``, '确定放弃编辑？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        center: true,
      }).then(async () => {
        this.$router.replace(`/story-manage/${this.from}`);
      });
    },
  },
  watch: {},
};
</script>

<style lang="less">
.pub-story-page {
  height: 100vh;
  width: 100%;
  .page-main {
    width: 1280px;
    height: calc(100% - 200px);
    min-height: 400px;
    margin: 0 auto;
    padding-bottom: 100px;
    padding-top: 100px;
    .edit-wrap {
      margin-top: 20px;
      margin-bottom: 100px;
      padding: 20px;
      border: 1px solid #e0e0e0;
      border-radius: 8px;
      .title-input {
        .el-form-item__content {
          margin-left: 0 !important;
        }
      }
      .foreword-input {
        .el-form-item__content {
          margin-left: 0 !important;
        }
      }
      .el-select {
        width: 100%;
      }
      .tags-form {
        margin-bottom: 5px;
        .tags-box {
          width: 100%;
          height: 40px;
          border: 1px solid #dcdfe6;
          .el-tag {
            margin-right: 10px;
          }
        }
      }
      .tips {
        margin-left: 120px;
        margin-bottom: 10px;
        font-size: 12px;
        color: #04cbcd;
      }
      .cascader-form {
        .el-cascader {
          width: 100%;
        }
      }
      .upload-img-item {
        .upload-img-wrap {
          height: 144px;
          .img-upload-btn {
            &:hover {
              .cover-list-select-wrap {
                display: none;
              }
            }
          }
          &.cross {
            width: 216px;
          }
          &.vertical {
            width: 92px;
          }
        }
        .tip-text {
          color: #93939d;
          line-height: 24px;
          display: block;
          font-size: 12px;
          &.mt6 {
            margin-top: 6px;
          }
          i {
            font-style: normal;
            color: #333;
          }
        }
      }
      .publish-area {
        margin-top: 20px;
        .m-btn {
          background: #04cbcd;
          color: #fff;
          &.publish {
            &:hover {
              opacity: 0.9;
            }
          }

          &.draft {
            background: #fff;
            color: #04cbcd;
            &:hover {
              opacity: 0.8;
            }
          }
          &.cancel {
            background: #fff;
            color: #333;
            border: 1px solid #ccc;
            &:hover {
              opacity: 0.8;
            }
          }
        }

        .content-length {
          font-size: 14px;
          color: #666;
        }
      }
    }
  }
}
</style>
